import Typography, { TypographyProps } from '@mui/material/Typography';
import * as colours from 'core/colors';
import { ReactNode } from 'react';

type MemreTextProps = {
  children: ReactNode;
  variant?: TypographyProps['variant'] | 'meta';
  singleLine?: boolean;
  sx?: any;
};

export default function MemreText({ children, variant = 'body1', sx = {}, singleLine = false }: MemreTextProps) {
  const extraStyles = singleLine ? { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } : {};

  if (variant === 'meta') {
    return (
      <Typography
        sx={{
          fontSize: '0.65rem',
          fontStyle: 'italic',
          fontWeight: 400,
          color: colours.darkGray,
          lineHeight: 1,
          ...extraStyles,
          ...sx,
        }}
      >
        {children}
      </Typography>
    );
  }

  return (
    <Typography variant={variant} sx={{ maxWidth: '800px', ...extraStyles, ...sx }}>
      {children}
    </Typography>
  );
}
